import { ATPDetails } from "common/clients/inventory/ATP/ATPDetails";
import { isEmpty } from "lodash";
import { ReplenishmentWarehouseSelectionState } from "transfers/create/store";

export const getSelectedProductsLotNumbersList = (
  dskus: string[],
  warehouseSelection: ReplenishmentWarehouseSelectionState
): Record<string, ATPDetails[] | undefined> => {
  const { selectedWarehouseId, unifiedInventory } = warehouseSelection;

  if (!selectedWarehouseId || !unifiedInventory || isEmpty(dskus)) {
    return {};
  }

  const warehouseInventory = unifiedInventory.rawInventoryBreakdown[selectedWarehouseId];
  return dskus.reduce((acc, dsku) => {
    const atpDetails = warehouseInventory[dsku]?.atpDetails;
    if (atpDetails) {
      acc[dsku] = atpDetails as ATPDetails[];
    }
    return acc;
  }, {});
};
